import { Form } from '@/components';
import { COLORS } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: ${COLORS.DARK_ONYX};
  height: 100%;
`;

export const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledBlock = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;
`;

export const StyledFieldsWrap = styled.div`
  width: 100%;
`;

export const StyledButton = styled(Button)`
  margin-top: auto;
  min-height: 2.85rem;
`;
